import { TITLE_MASKED_FILTER_TYPES } from "../../constants/constants";

export const TitleMaskedFilter = (value, limit) => {
    if(value.length > limit) {
        value = value.substring(0, limit - TITLE_MASKED_FILTER_TYPES.DOTTED_NUMBER) + TITLE_MASKED_FILTER_TYPES.DOTTED_CHARS;
    }

    return value;
};



// WEBPACK FOOTER //
// ../source/common/utils/filters/titleMaskedFilter.js